

import React from 'react';
import {useSelector} from 'react-redux';

const Immagine  = (props) => {

    const dataImagePath = useSelector(state => state.dataReducer.dataImagesPath);
    let urlDirectoryImages = null;
    
    if(dataImagePath !== null){
        urlDirectoryImages = `${dataImagePath}${props.urlImage}`;
    }else{
        urlDirectoryImages = `/images/${props.urlImage}`;
    }
    
    return (
        <img src={urlDirectoryImages} onClick={props.clicked} className={props.class} alt={props.name}  style={props.styleInline} key={props.chiave}  />
    );
}

export default Immagine;